import React, { useState, useContext } from 'react';
import Grid from '@mui/material/Grid';
import { Context } from '../../Content';
import CustomButton from '../components/CustomButton'
import CorporateContactInfo from '../components/CorporateContactInfo';
import { validateInputs } from '../components/validateInputs.js';
import { smoothScroll } from '../components/smoothScroll.js';

function CorporateContactInfoForm(props) {
	const [inputDataContext, isCorrectTransitionContext] = useContext(Context);
	const { inputData, setInputData } = inputDataContext;

	const [contactDepartment, setContactDepartment] = useState(inputData['CorporateContactInfoForm'] === undefined ? '' : inputData['CorporateContactInfoForm'].contactDepartment);
	const [contactName, setContactName] = useState(inputData['CorporateContactInfoForm'] === undefined ? '' : inputData['CorporateContactInfoForm'].contactName);
	const [contactNameFurigana, setContactNameFurigana] = useState(inputData['CorporateContactInfoForm'] === undefined ? '' : inputData['CorporateContactInfoForm'].contactNameFurigana);
	const [contactEmail, setContactEmail] = useState(inputData['CorporateContactInfoForm'] === undefined ? '' : inputData['CorporateContactInfoForm'].contactEmail);
	const [contactPhoneNumber, setContactPhoneNumber] = useState(inputData['CorporateContactInfoForm'] === undefined ? '' : inputData['CorporateContactInfoForm'].contactPhoneNumber);
	const [contactAddressType, setContactAddressType] = useState(inputData['CorporateContactInfoForm'] === undefined ? '0' : inputData['CorporateContactInfoForm'].contactAddressType);
	const [postalCode, setPostalCode] = useState(inputData['CorporateContactInfoForm'] === undefined ? '' : inputData['CorporateContactInfoForm'].postalCode);
	const [region, setRegion] = useState(inputData['CorporateContactInfoForm'] === undefined ? '' : inputData['CorporateContactInfoForm'].region);
	const [city, setCity] = useState(inputData['CorporateContactInfoForm'] === undefined ? '' : inputData['CorporateContactInfoForm'].city);
	const [address1, setAddress1] = useState(inputData['CorporateContactInfoForm'] === undefined ? '' : inputData['CorporateContactInfoForm'].address1);
	const [address2, setAddress2] = useState(inputData['CorporateContactInfoForm'] === undefined ? '' : inputData['CorporateContactInfoForm'].address2);
	const [errMessage, setErrMessage] = useState('');

	// ステップ移動時の処理
	const handleTransitionNext = () => {
		const json = { contactDepartment, contactName, contactNameFurigana, contactEmail, contactPhoneNumber, contactAddressType, postalCode, region, city, address1, address2 };
		const [isErr, message] = contactAddressType === '0' ? validateInputs(json) : validateInputs({ contactDepartment, contactName, contactNameFurigana, contactEmail, contactPhoneNumber });
		setErrMessage([]);
		if (isErr) {
			setErrMessage(message);
			smoothScroll(Object.keys(message)[0]);
		}
		else {
			setInputData({ ...inputData, 'CorporateContactInfoForm': json });
			props.handleTransition('/self/corporate/accountinfo');
		}
	};

	return (
		<Grid container spacing={3} alignItems='center' justifyContent='center' direction='column'>
			<Grid item alignItems='flex-start' style={{ width: '100%' }}>
				<p>担当者名と連絡先をご入力ください。</p>
			</Grid>

			<Grid item style={{ width: '100%', textAlign: 'center' }}>
				<CorporateContactInfo
					contactDepartment={contactDepartment}
					contactName={contactName}
					contactNameFurigana={contactNameFurigana}
					contactEmail={contactEmail}
					contactPhoneNumber={contactPhoneNumber}
					contactAddressType={contactAddressType}
					postalCode={postalCode}
					region={region}
					city={city}
					address1={address1}
					address2={address2}
					setContactDepartment={setContactDepartment}
					setContactName={setContactName}
					setContactNameFurigana={setContactNameFurigana}
					setContactEmail={setContactEmail}
					setContactPhoneNumber={setContactPhoneNumber}
					setContactAddressType={setContactAddressType}
					setPostalCode={setPostalCode}
					setRegion={setRegion}
					setCity={setCity}
					setAddress1={setAddress1}
					setAddress2={setAddress2}
					errMessage={errMessage}
					setErrMessage={setErrMessage}
				/>
			</Grid>

			<Grid item>
				<CustomButton
					label='次へ'
					variant='contained'
					onClick={handleTransitionNext}
				/>
			</Grid>

			<Grid item>
				<CustomButton
					label='戻る'
					variant='text'
					onClick={() => props.handleTransition('/self/corporate/basicinfo')}
				/>
			</Grid>
		</Grid>
	)
}

export default CorporateContactInfoForm